import { render, staticRenderFns } from "./LactationStatus.vue?vue&type=template&id=32875a46&scoped=true&"
import script from "./LactationStatus.vue?vue&type=script&lang=js&"
export * from "./LactationStatus.vue?vue&type=script&lang=js&"
import style0 from "./LactationStatus.vue?vue&type=style&index=0&id=32875a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32875a46",
  null
  
)

export default component.exports